import { PageDescription } from '../PageDescription/PageDescription';
import { ResponsivePageDescription } from '../PageDescription/ResponsivePageDescription';
import { PageHeading } from '../PageHeading/PageHeading';
import { ResponsivePageHeading } from '../PageHeading/ResponsivePageHeading';
import { PageHeaderRoot } from './pageHeader.style';
import type { PageHeaderProps } from '../../types';

/**
 * PageHeader
 *
 * Shared page/section header combining a heading and an optional description,
 * stacked with consistent spacing.
 *
 * Pass `isResponsive` to switch both the heading and description to their
 * responsive variants, which adapt font sizes per breakpoint via the typography
 * scale. Omitting the prop (or passing `false`) renders the static variants.
 */
export const PageHeader = ({
    heading,
    description,
    isResponsive = false,
    'data-testid': dataTestId = 'page-header'
}: PageHeaderProps) => {
    const Heading = isResponsive ? ResponsivePageHeading : PageHeading;
    const Description = isResponsive ? ResponsivePageDescription : PageDescription;

    return (
        <PageHeaderRoot data-testid={dataTestId}>
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
        </PageHeaderRoot>
    );
};

export default PageHeader;
